window.TeamCommunicationAPI = new function () {

    var self = this;

    var _protected = BaseAPI.call(self);
    var url = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.TSTeamCommunicationServerBaseURL : publicConfiguration.TeamCommunicationServerBaseURL;
    _protected.setApiUrl(url);

    self.getURL = function () {
        return url;
    };

    self.getPosts = function (brandId, postId, isBefore, limit) {
        limit = limit || 10;
        var fetch = (isBefore) ? "before" : "after";

        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + "brands/" + brandId + "/posts", "GET", {
            fetch: fetch,
            post_id: postId,
            limit: limit
        })
            .then(function (res) {
                    if (res.data && res.status == 200) {
                        var posts = res.data.data && res.data.data.posts;
                        deferred.resolve(posts);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.deletePost = function (brandId, postId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/posts/" + postId, "DELETE")
            .then(function (res) {
                    if (res.data && res.status == 200) {
                        var posts = res.data.data && res.data.data.posts;
                        deferred.resolve(posts);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(res);
                });

        return deferred.promise;
    };

    self.addCommentToPost = function (brandId, postId, comment) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/posts/" + postId + "/comments", "POST", {
            content: comment
        })
            .then(function (res) {
                    if (res.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getPostComments = function (brandId, postId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/posts/" + postId + "/comments", "GET")
            .then(function (res) {
                    if (res.status === 200 && res.data?.data) {
                        deferred.resolve(res.data.data.comments);
                    }
                    else {
                        deferred.reject(res);
                    }

                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    /**
     * Gets unread messages between logged in user and the user in the params
     *
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getUnreadMessagesCount = function () {
        var deferred = $q.defer();
        _protected.request("users/conversations/unread_messages/count", "GET").then(function (res) {
                if (res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data.count);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEmployeeUnreadMessagesCount = function (brandId) {
        var deferred = $q.defer();
        _protected.request("employees/brands/" + brandId + "/users/conversations/unread_messages/count", "GET").then(function (res) {
                if (res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data.count);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get user's unseen posts and messages - brand or employee
     *
     * @param brandId
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getUserNotificationsCounts = function (brandId) {
        var deferred = $q.defer();

        var params = {};

        _protected.request("brands/" + brandId + "/notifications/counts", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.status == 200) {
                    var counts = {
                        post: {},
                    };
                    for (var i in res.data.data.counts) {
                        if (res.data.data.counts[i].type == "POST") {
                            counts.post.count = res.data.data.counts[i].count;
                        }
                    }
                    deferred.resolve(counts);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.canCommunicateWithUser = function (brandId, userId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new Error('Brand id is required  ' + Date.now());
        }

        if (!userId) {
            throw new Error('User id is required  ' + Date.now());
        }

        var params = {
            user_ids: [userId]
        };

        _protected.request("employees/brands/" + brandId + "/conversations/check", "GET", params)
            .then(function (res) {
                    if (res.data) {
                        deferred.resolve(res.data.data);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getChSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new Error('Brand id is required  ' + Date.now());
        }

        _protected.request("brands/" + brandId + "/services/ENTERPRISE_COMMUNICATION/settings", "GET")
            .then(function (res) {
                    if (res.data) {
                        deferred.resolve(res.data.data);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.updateChSettings = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new Error('Brand id is required  ' + Date.now());
        }

        _protected.request("brands/" + brandId + "/services/ENTERPRISE_COMMUNICATION/settings", "PUT", payload)
            .then(function (res) {
                    if (res.data) {
                        deferred.resolve(res.data.data);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });
        return deferred.promise;
    };

    /**
     * Get unread messages count --> for harri engage messages
     *
     * @param moduleName
     * @returns {deferred.promise|{then, always}|{then}}
     */

    self.getUnreadMessagesByModule = function (moduleName) {
        const deferred = $q.defer();

        if (!moduleName) {
            throw new Error('Module name is required  ' + Date.now());
        }

        _protected.request(`employees/users/conversations/unread_messages/count_per_business`, "GET", {
            created_by_type: moduleName
        })
            .then(function (res) {
                    if (res.status == 200 && res.data?.data) {
                        deferred.resolve(res.data.data.brands);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });
        return deferred.promise;
    };
};
